import React, { useState } from 'react';
// import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
//import './index.css';
// import Api from "../ServiceApi";
// import Cookies from "js-cookie";
import { css } from "emotion";
import { Table, Input, InputNumber, Popconfirm, Form, Button } from 'antd';
// const originData = [];
// const num_row = -1; 

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          // rules={[
          //   {
          //     required: true,
          //     message: `Please Input ${title}!`,
          //   },
          // ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const DynamicEditable = (props) => { 
  const [form] = Form.useForm();
  const data_dynamic = props.data_dynamic

  let len_data = (data_dynamic)?data_dynamic.length:0
  //console.log(len_data,'len_data');
  if(len_data > 0){
    data_dynamic.map((item, i) => {
      item["key"] = i
    });
  }

  const [data, setData] = useState(data_dynamic);
  const [count, setCount] = useState(len_data-1)
  const [editingKey, setEditingKey] = useState('');
  const isEditing = (record) => record.key === editingKey;

  // const tableCSS = css({
  //   margin: "0px",
  //   backgroundColor: "white",
  //   "& table": { borderCollapse: "collapse" },
  //   "& tbody > tr:nth-child(even)": { backgroundColor: "#0F0" },
  //   "& tbody > tr:nth-child(odd)": { backgroundColor: "#0F9" },
  //   //"& tbody > tr:nth-child(even):hover > td": { backgroundColor: "#090 !important" },//change color row when hover
  //   "& tbody > tr:hover > td": { background: "none !important" }, //disable row hover
  //   "& thead > tr > th": { backgroundColor: "darkblue", color: "white" },
  //   "& thead > tr": {
  //     borderWidth: "2px",
  //     borderColor: "#91F",
  //     borderStyle: "solid",
  //   },
  // });

  const tableCSS = css({
    margin: "0px",
    backgroundColor: "white",
    "& table": { width: "auto !important" , whiteSpace: "nowrap"  },
  });

  const edit = (record) => {
    //console.log(record,'record');
    form.setFieldsValue({
      ...record
    });
    
    setEditingKey(record.key);
  };

  const cancel = () => {
    setEditingKey('');
  };

  const save = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);   

      if (index > -1) {
        const item = newData[index];    
        newData.splice(index, 1, { ...item, ...row });
        setData(newData);
        setEditingKey('');
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey('');
      }

      props.parentUpdate(newData, props.table_id);
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };

  const handleDelete = (key) => {
    let newData = [...data];
    const delData = newData.filter((item) => item.key !== key);
    setData(delData);
    props.parentUpdate(delData, props.table_id);
  }

  const handleAdd = (col_edit) => {
    let newData = (data !== undefined)?[...data]:[];
    let newCount = count+1;
    let newRow = {
      key: newCount
    }
    col_edit.map((item, i) => {
      //console.log('key : '+item.key);
      newRow[item.key] = ''
    });

    newData.push(newRow)
    setData(newData);
    setCount(newCount);
    props.parentUpdate(newData, props.table_id);
  }

  const col_edit = JSON.parse(JSON.stringify(props)).col
  let cloneCol = JSON.parse(JSON.stringify(props)).col; // clone
  cloneCol.map((item, i) => {
    item.editable = true;
  });
  cloneCol.push(
    {
      key: "operation",
      title: 'operation',
      dataIndex: 'operation',
      width: '9%',
      fixed: "right",
      render: (_, record) => {
        const editable = isEditing(record);
        return <span>
          { editable ? (
            <span>
              <a
                // href="javascript:;"            
                onClick={() => save(record.key)}
                style={{
                  marginRight: 8,
                }}
              >
                Save
              </a>
              <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                <a>Cancel</a>
              </Popconfirm>
            </span>
          ) : (
            <a disabled={editingKey !== ''} onClick={() => edit(record)}>
              Edit
            </a>
          )
        }
        &nbsp;&nbsp; | &nbsp;&nbsp;
        {
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record.key)}
          >
            <a disabled={editingKey !== ''}>Delete</a>
          </Popconfirm>
        }
        </span>

      },
    }    
  );

  const width_scroll = 150 * cloneCol.length;

  const columns = [
    {
      title: 'name',
      dataIndex: 'name',
      width: '25%',
      editable: true,
    },
    {
      title: 'age',
      dataIndex: 'age',
      width: '15%',
      editable: true,
    },
    {
      title: 'address',
      dataIndex: 'address',
      width: '40%',
      editable: true,
    },
    {
      title: 'operation',
      dataIndex: 'operation',
      render: (_, record) => {
        const editable = isEditing(record);
        return <span>
          { editable ? (
            <span>
              <a
                // href="javascript:;"            
                onClick={() => save(record.key)}
                style={{
                  marginRight: 8,
                }}
              >
                Save
              </a>
              <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                <a>Cancel</a>
              </Popconfirm>
            </span>
          ) : (
            <a disabled={editingKey !== ''} onClick={() => edit(record)}>
              Edit
            </a>
          )
        }
        &nbsp;&nbsp; | &nbsp;&nbsp;
        {
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => handleDelete(record.key)}
          >
            <a disabled={editingKey !== ''} >Delete</a>
          </Popconfirm>
        }
        </span>

      },
    },
  ];

  const mergedColumns = cloneCol.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        //inputType: col.dataIndex === 'age' ? 'number' : 'text',
        inputType: 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <Form form={form} component={false}>
      <Button
          onClick={() => handleAdd(col_edit)}
          type="primary"
          style={{
            marginBottom: 16,
          }}
        >
          Add a row
      </Button>
      <Table
        className={css(tableCSS)}
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        bordered
        dataSource={data}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={{
          onChange: cancel,
        }}
        scroll={{ x: width_scroll }}
      />
    </Form>
  );
};

export default DynamicEditable;